module.exports = "<h2 id=\"component-description\">Component Description</h2>\n<p>A TabButton is a wrapper <code>&lt;button&gt;</code> use to contain Nessie Tab component for example in the creation of Nessie Tabs menus.</p>\n<h2 id=\"example-usage\">Example Usage</h2>\n<pre><code>&lt;TabButton label=&quot;Tab title&quot; subtitle=&quot;Some subtitle&quot; /&gt;\n</code></pre>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader!./node_modules/markdown-loader!./src/TabButton/README.md
// module id = 394
// module chunks = 0